'use strict';

var log = require('../../log/Log').channel('SetupLanguageController');
var defaults = require('../../defaults/Defaults');
require('./LanguageService');

angular.module('inara').controller('SetupLanguageController', SetupLanguageController);

SetupLanguageController.$inject = ['$scope', '$state', 'RoomService',
                                   'LanguageService', 'gettextCatalog'];

function SetupLanguageController($scope, $state, RoomService,
                                 LanguageService, gettextCatalog) {
    var vm = this;
    vm.languageList = LanguageService.getLanguages();
    for (var i in Object.keys(vm.languageList)) {
        if (vm.languageList[i].code === defaults.inara.language) {
            vm.language = vm.languageList[i];
            break;
        }
    }
    var controller = RoomService.getController();
    // Controller may be null if not connected to a network and offline cache
    // is non-existant
    if (controller !== null) {
        controller.$loaded().then(function() {
            if (angular.isDefined(controller.language)) {
                var found = vm.languageList.find(function(el) {
                    return el.code === controller.language;
                });
                if (found) {
                    vm.language = found;
                }
            }
        });        
    }

    log.info('initializing');

    /// Title bar for setup select language page
    vm.getViewTitle = function() { return gettextCatalog.getString('Select Application Language'); };

    vm.onLanguageChanged = function() {
        // If controller is null, don't try to save the language setting now,
        // it will also be set when finishing setup.
        if (controller === null) {
            LanguageService.setLanguage(vm.language.code);
            return;
        }
        controller.language = vm.language.code;
        controller.$save();
    };

    vm.continue = function () {
        $scope.setup.language = vm.language;
        $scope.goTo('setup.network');
    };
}

module.exports = SetupLanguageController;
